module.exports = __webpack_public_path__ + "static/media/etf.cd5df618.png";